import { render, staticRenderFns } from "./input-area.vue?vue&type=template&id=c6d2e7f8&scoped=true&"
import script from "./input-area.vue?vue&type=script&lang=js&"
export * from "./input-area.vue?vue&type=script&lang=js&"
import style0 from "./input-area.vue?vue&type=style&index=0&id=c6d2e7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d2e7f8",
  null
  
)

export default component.exports